import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import { RecoilRoot } from 'recoil';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import { initSentry } from './sentry';
import {
  SentryErrorBoundary,
  ErrorFallback,
} from './Components/ErrorBoundary/ErrorBoundary';

// Initialize Sentry before rendering the app
initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <SentryErrorBoundary fallback={<ErrorFallback />}>
    <HelmetProvider>
      <BrowserRouter>
        <RecoilRoot>
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: '#11a5ea',
              },
            }}
          >
            <App />
          </ConfigProvider>
        </RecoilRoot>
      </BrowserRouter>
    </HelmetProvider>
  </SentryErrorBoundary>
);
